export default "__VITE_ASSET__tTlwAaz2__"